var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.749695,
    y: 0.75,
    width: 24.4189,
    height: 23.0897,
    rx: 6.25,
    fill: "#E78080",
    stroke: "#E78080",
    strokeWidth: 1.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_802_21429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5569 9.71915C17.5569 9.39799 17.2965 9.13764 16.9754 9.13764H15.5115C15.2665 8.44267 14.6108 7.97697 13.8739 7.97461H12.7109C11.974 7.97697 11.3183 8.44267 11.0734 9.13764H9.6095C9.28834 9.13764 9.02798 9.39799 9.02798 9.71915C9.02798 10.0403 9.28834 10.3007 9.6095 10.3007H9.80334V15.1466C9.80334 16.3242 10.758 17.2788 11.9356 17.2788H14.6493C15.8269 17.2788 16.7815 16.3242 16.7815 15.1466V10.3007H16.9754C17.2965 10.3007 17.5569 10.0403 17.5569 9.71915ZM15.6185 15.1466C15.6185 15.6819 15.1846 16.1158 14.6493 16.1158H11.9356C11.4003 16.1158 10.9664 15.6819 10.9664 15.1466V10.3007H15.6185V15.1466Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3232 14.9527C12.6444 14.9527 12.9048 14.6924 12.9048 14.3712V12.0451C12.9048 11.724 12.6444 11.4636 12.3232 11.4636C12.0021 11.4636 11.7417 11.724 11.7417 12.0451V14.3712C11.7417 14.6924 12.0021 14.9527 12.3232 14.9527Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2616 14.9527C14.5828 14.9527 14.8431 14.6924 14.8431 14.3712V12.0451C14.8431 11.724 14.5828 11.4636 14.2616 11.4636C13.9405 11.4636 13.6801 11.724 13.6801 12.0451V14.3712C13.6801 14.6924 13.9405 14.9527 14.2616 14.9527Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_802_21429"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.30423,
    height: 9.30423,
    fill: "white",
    transform: "translate(8.64032 7.97461)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.bede600e.svg";
export { ForwardRef as ReactComponent };